<template>
    <div class="card asset-preview">
        <div class="card-body p-0">
            <div class="m-3" style="position: relative">
                <div class="row no-gutters">
                    <div class="col-5">
                        <div
                            class="thumbnail"
                            @click="openEditor()"
                            style="cursor: pointer"
                            v-b-tooltip.hover
                            :title="$root.text('Edit scene', null, true)"
                        >
                            <img :src="image_src" :alt="title">
                        </div>
                    </div>
                    <div class="col pl-3">
                        <div class="title mb-2 text-dark font-size-15" :id="'scene-title' + id" @click="openEditor()">
                            {{ short_title }}
                        </div>
                        <b-tooltip
                            v-if="(short_title != title)"
                            :target="'scene-title' + id"
                            triggers="hover"
                        >
                            {{ title }}
                        </b-tooltip>
                        <p v-if="scene" v-html="addedBy()"></p>
                    </div>
                </div>
            </div>
            <hr class="mb-0">
            <div class="mx-3" style="margin-top: 12px; margin-bottom: 12px; min-height: 25px">
                <span v-if="finished" class="badge badge-success font-size-11" style="padding: 7px">
                    <i class="far fa-check mr-1"></i> {{ $root.text('Finished', null, true) }}
                </span>
                <span v-if="!finished && ready_for_tagging" class="badge badge-light font-size-11" style="padding: 7px">
                    <i class="far fa-tags mr-1"></i> {{ $root.text('Ready for tagging', null, true) }}
                </span>
                <span class="float-right">
                    <button
                        v-if="finished"
                        :key="'add-template-button'"
                        type="button"
                        class="btn btn-secondary btn-sm mr-2"
                        @click="addTemplate()"
                        :disabled="downloading"
                    >
                        <i class="fal fa-send-back mr-1"></i>
                        {{ $root.text(
                            'Add {template}',
                            {
                                template: $root.text(
                                    $root.contents.template_title,
                                    null,
                                    false,
                                    'template_title'
                                )
                            },
                            true
                        ) }}
                    </button>

                    <button
                        v-if="!downloading"
                        :key="'edit-button'"
                        type="button"
                        class="btn btn-primary btn-sm"
                        @click="openEditor()"
                    >
                        <i class="far fa-edit mr-1"></i>
                        {{ $root.text('Edit', null, true) }}
                    </button>
                    <button v-else :key="'editing-button'" type="button" class="btn btn-primary btn-sm">
                        <i class="fal fa-spinner-third fa-spin mr-1"></i>
                        <span style="opacity: 0.5">{{ $root.text('Edit', null, true) }}</span>
                    </button>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['data'],
        data () {
            return {
                id: 0,
                image_src: '/images/file-icon.png',
                title: '',
                short_title: '',
                finished: false,
                ready_for_tagging: false,
                scene: null,
                file: null,
                downloading: false,
                scene_data: null,
                window_width: 0,
                check_width_interval: null
            }
        },
        mounted () {
            if (this.data) {
                this.updateData(this.data);
            }
            var vm = this;
            $(window).resize(function () {
                vm.setWidth();
            });
            vm.check_width_interval = setInterval(function () {
                if (vm.window_width != $(window).width()) {
                    vm.setWidth();
                }
            }, 1010);
        },
        beforeDestroy() {
            clearInterval(this.check_width_interval);
        },
        watch: {
            data: function (val) {
                if (val) {
                    this.updateData(val);
                }
            }
        },
        methods: {
            setWidth: function () {
                this.window_width = $(window).width();
                var vm = this;
                vm.short_title = vm.title;
                setTimeout(function () {
                    vm.fitTitle();
                }, 500);
            },
            updateData: function (data) {
                this.id = data.id;
                this.title = data.title;
                this.short_title = data.title;
                this.finished = data.finished;
                this.ready_for_tagging = data.ready_for_tagging;
                this.getScene();
                this.getPreviewImage();
                var vm = this;
                setTimeout(function () {
                    vm.fitTitle();
                }, 500);
            },
            fitTitle: function () {
                if (!$('#scene-title' + this.id)[0]) {
                    var vm = this;
                    setTimeout(function () {
                        vm.fitTitle();
                    }, 200);

                    return null;
                }
                if ($('#scene-title' + this.id)[0].scrollHeight > 45) {
                    let words = this.short_title.split(' ');
                    words.pop();
                    if (words.length > 0) {
                        this.short_title = words.join(' ') + '...';
                        var vm = this;
                        setTimeout(function () {
                            vm.fitTitle();
                        }, 200);
                    }
                }
            },
            getScene: function () {
                /**
                 * Send request to API.
                 */
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/img-ly-scene/' + this.id;
                var vm = this;

                axios({
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    vm.scene = response.data.scene;
                    vm.file = response.data.file;
                })
                .catch(function (error) {
                    // Show any errors?
                });
            },
            getPreviewImage: function () {
                /**
                 * Send request to API.
                 */
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/img-ly-scene/' + this.id
                    + '/preview/lowres';
                var vm = this;

                axios({
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    if (response.data.image_src) {
                        vm.image_src = response.data.image_src;
                    }
                })
                .catch(function (error) {
                    // Show any errors?
                });
            },
            addedBy: function () {
                if (!this.scene.created_by_name) {
                    return this.$root.text('Added: {date}', { date: this.scene.created_at_formatted }, true);
                }

                return this.$root.text('Added by: {name}', { name: this.scene.created_by_name }, true)
                    + ' &nbsp; ' + this.scene.created_at_formatted;
            },
            openEditor: function () {
                if (this.scene_data) {
                    const appComponent = this.$root.findComponent(this.$root, 'main-app');
                    appComponent.showImgLySceneEditor(this.scene_data, this.scene);
                    this.downloading = false;

                    return null;
                }
                this.downloading = true;
                var vm = this;

                if (!this.file) {
                    setTimeout(function () {
                        vm.openEditor();
                    }, 1000);

                    return null;
                }

                /**
                 * Send request to API.
                 */
                const download = this.file;
                const data = {
                    item_type: 'img_ly_scene',
                    item_id: this.scene.id,
                    file_path: download.file_path,
                    file_type: download.file_type,
                    download_filename: download.filename + '.' + download.extension
                };
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/request-download-token';

                axios({
                    method: 'post',
                    url: url,
                    data: data,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    const downloadUrl = vm.$root.app.api_url + '/' + vm.$root.app.client_id + '/download/'
                        + response.data.token;

                    axios({
                        url: downloadUrl,
                        headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                    })
                    .then(response => {
                        vm.scene_data = response.data;
                        setTimeout(function () {
                            vm.openEditor();
                        }, 200);
                    })
                    .catch(function (error) {
                        vm.downloading = false;
                        // Show any errors?
                    });
                })
                .catch(function (error) {
                    vm.downloading = false;
                    // Show any errors?
                });
            },
            addTemplate: function () {
                alert('Add template from scene TBD...');
            }
        }
    }
</script>
<style scoped>
    .asset-preview .thumbnail {
        height: 150px;
        overflow: hidden;
        border-top-left-radius: unset;
        border-top-right-radius: unset;
    }

    .asset-preview .thumbnail img {
        max-height: 148px;
    }

    .asset-preview .card-body .title {
        height: 38px;
        line-height: 18px;
        font-weight: 500;
        cursor: pointer;
        overflow-wrap: anywhere;
    }
</style>
